module.exports = __webpack_public_path__ + "img/pc-no-support-icon.9c61ebf5.svg";